import { render } from "./Picks.vue?vue&type=template&id=f5b54d32"
import script from "./Picks.vue?vue&type=script&lang=js"
export * from "./Picks.vue?vue&type=script&lang=js"

import "./Picks.vue?vue&type=style&index=0&id=f5b54d32&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__